import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Table from "./Table";
import Button from "../../../../Core/Button/Button";
import printerimg from "../../../../assets/print.png";
import { useLocation, useNavigate } from "react-router-dom";
import FormLayout from "../../../../Core/Layout/FormLayout";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import { useGetStockEntryDetailsQuery } from "../../../../store/api/putawayapi";
import Attachment from "../../../../utils/Attachment";

const PurchaseForm = () => {
  const nvg = useNavigate()
  const location = useLocation();
  const putawayid = location?.state.putaway_no;
  console.log(putawayid,"putawayid");
  
  const status = location?.state.status
  const [activityboll, setactivityboll] = useState(false)
  const [date, setDate] = useState('')
  const [grn, setGrn] = useState('')
  const [no, setNo] = useState('')
  const [potime, setPOtime] = useState('')
  const [vendor, setVendor] = useState('')
  const [sourceWarehouse, setSourceWarehouse] = useState('');
  const [totalScannedQty, setTotalScannedQty] = useState(0);
  const [finalstep, setfinalstep] = useState(false);
  const [tab, settab] = useState(1)
  const [item_Rows, setitem_Rows] = useState([]);
  const [ptype, setptype] = useState("Error")
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const [poOrder, setPorder] = useState('')
  const [blinkRow, setblinkRow] = useState(null);
  const [currentBin, setCurrentBin] = useState(null);
  const { data: detaildata, iserror, isLoading } = useGetStockEntryDetailsQuery(putawayid)

  useEffect(() => {

    if (detaildata?.data) {
      console.log("check resppse", detaildata);
      setactivityboll(true);
      setNo(detaildata?.data.name);
      setGrn(detaildata?.data.against_purchase_receipt);
      setDate(detaildata?.data.creation.split(' ')[0])
      setVendor(detaildata?.data.supplier_name)
      setPOtime(detaildata?.data.posting_time.split(' ')[0])
      setitem_Rows(detaildata?.data.items)
      setPorder(detaildata?.data.purchase_order_no)
      if (detaildata.data.items.length > 0) {
        setSourceWarehouse(detaildata.data.items[0].s_warehouse);
        const totalScanned = detaildata.data.items.reduce(
          (sum, item) => sum + (item.scan_received_qty || 0),
          0
        );


        setTotalScannedQty(totalScanned);
      }
    }
  }, [detaildata])




  return (

    <>
      <FormLayout
        title="View Putaway"
        breadcrumbs={[
          { label: "Inbound" },
          { label: "Putaway  List", url: "/inbound/putaway/create-in-putaway" }
        ]}
        status={status}
        // status={"hide"}
        finalStep={finalstep}
        actionButtons={
          <>
            {/* <p className="p-0 m-0">
              <img src={printerimg}
                onClick={() => setShowPrintModal(true)}
                className="px-2" style={{ width: '35px', cursor: 'pointer' }} alt="404" />
            </p> */}
          </>
        }
      ></FormLayout>


      <div className="d-flex flex-column" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                  <div className="d-flex justify-content-between align-items-end ">
       
          <ul
            className="nav nav-tabs"
            style={{ color: "white", border: "none" }}
          >
            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
              <a className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
              </a>
            </li>
          </ul>
                    <Attachment doctype="Stock Entry"  docname={putawayid}  /> 
</div>
        </div>
        <div className="row d-flex justify-content-between" style={{ marginTop: '14px', flexGrow: '1' }}>
          <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <Tab1 poOrder={poOrder} date={date} no={no} grn={grn} vendor={vendor} potime={potime} sourceWarehouse={sourceWarehouse} activityboll={activityboll} />
          </div>
          <div className="col-9 d-flex" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', flexDirection: 'column' }}>
            <div className="d-flex justify-content-between pb-2" style={{ gap: '5px' }}>
              <div className="d-flex" style={{ gap: '5px' }} >
                <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {item_Rows.length}</span></p>
                <p className="TotalQty">Ordered Quantity -  <span style={{ color: '#16A34A' }}>{totalScannedQty}</span></p>
                <p className="ReceivedQty">Scanned Quantity -  <span style={{ color: '#EC642A' }}>{totalScannedQty}</span></p>
              </div>
              <div className="d-flex mb-2">

              </div>
            </div>
            <div className="tableLabel">
              <div style={{ width: '99%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
              <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '3px', fontSize: '15px' }}>Item Details</p>
            </div>
            <Table item_Rows={item_Rows} blinkrow={blinkRow} currentBin={currentBin?.name || ''} />
          </div>
        </div>
      </div>
        {/* {showPrintModal && (
                <PrintModal 
                    onClose={() => setShowPrintModal(false)}
                    documentId={putawayid}
                    doctype="Stock Entry"
                    title="Print PutAway"
                />
            )} */}
      <ApiResponseBox poptype={ptype} show={showError} errorMessage={error} onClose={() => setShowError(false)} />
    </>
  );
};

export default PurchaseForm;
